import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { Skeleton } from '../ui/skeleton';

export function ProtectedRoute({ children, requiredRoles }) {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center" style={{ background: 'hsl(var(--muted))' }}>
        <div className="space-y-3 w-64">
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Redirect to force-reset if required (but not if already on that page)
  if (user?.force_reset_password && location.pathname !== '/auth/reset-password') {
    return <Navigate to="/auth/reset-password" replace />;
  }

  // Role-based access check
  if (requiredRoles && !requiredRoles.includes(user?.role)) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <h2 className="text-lg font-semibold text-red-600">Access Denied</h2>
          <p className="text-sm mt-1" style={{ color: 'hsl(var(--muted-fg))' }}>You don't have permission to view this page.</p>
        </div>
      </div>
    );
  }

  return children;
}
